import React, {ChangeEvent, useState} from 'react';
// @ts-ignore
import {createField, fieldPresets} from 'react-advanced-form'

import {FieldProp} from '../../types';
import {Modal} from '../Modal';

type TextareaProps = FieldProp & {};

const Textarea: React.FunctionComponent<TextareaProps> = ({
                                                              field,
                                                              fieldState,
                                                              value,
                                                              displayOnly,
                                                              onChange,
                                                              onBlur,
                                                          }): JSX.Element => {
    const [showModal, setShowModal] = useState(false);

    const {
        touched,
        pristine,
        validating,
        valid,
        invalid,
        errors,
    } = fieldState;

    const classNames = [
        'form-control',
        'd-print-none',
        touched && 'is-touched',
        pristine && 'is-pristine',
        validating && 'is-validating',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    const displayMode = field?.flowCustomDisplayComponentConfig?.display?.mode || 'default';
    const displayModalOptions = {
        buttonText: 'view',
        size: 'lg',
        buttonClasses: '',
        ...field?.flowCustomDisplayComponentConfig?.display?.modal
    }

    const displayRows = field?.flowCustomDisplayComponentConfig?.rows || 5;

    const renderTextArea = () => {
        return (
            <>
                {displayOnly ? <pre className="form-field-value">{value}</pre> :
                    <div>
                        <textarea
                            id={field.htmlId}
                            required={field.isRequired}
                            readOnly={field.gwreadonly_enable}
                            className={classNames}
                            onBlur={() => {
                                onBlur && onBlur()
                            }}
                            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                                onChange(e.target.value)
                            }}
                            value={value}
                            placeholder={field.placeholder}
                            rows={displayRows}
                        />
                        <pre className="form-field-value d-none d-print-block">{value}</pre>
                    </div>
                }

                <div className="d-flex">
                    <div className="flex-grow-1">
                        {errors && errors.map((error: string, index: number) => (
                            <div key={index} className="invalid-feedback">
                                {error}
                            </div>
                        ))}
                    </div>

                    {!displayOnly && field.maxLength &&
                        <div className="text-right">
                            <span className="small text-muted">{value?.length || 0} of {field.maxLength}</span>
                        </div>
                    }
                </div>
            </>
        );
    }

    return (
        <div>
            {displayMode === 'default' ?
                renderTextArea()
                :
                <>
                    <button type="button"
                            className={`btn btn-link ${displayModalOptions.buttonClasses}`}
                            onClick={() => {
                                setShowModal(true)
                            }}
                    >{displayModalOptions.buttonText}</button>

                    {showModal &&
                        <Modal size={displayModalOptions.size}>
                            <div className="modal-header">
                                <h5 className="modal-title">{field?.label}</h5>
                                <button type="button"
                                        className="close"
                                        tabIndex={-1}
                                        onClick={() => {
                                            setShowModal(false);
                                        }}
                                >×
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    {renderTextArea()}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {
                                            setShowModal(false);
                                        }}
                                >Close
                                </button>
                            </div>
                        </Modal>
                    }
                </>
            }
        </div>
    );
};
const TextareaMemoized = React.memo(Textarea);
export {TextareaMemoized as Textarea};
